import uuid from 'uuid/v4';

export default () => ({
  files: [],
  type: null,
  opened: false,
  mode: null,
  currentStep: {
    id: null,
  },
  form: {
    id: uuid(),
    name: null,
    width: null,
    height: null,
    count: 1,
    files: [],
    style: { id: null, name: null },
    material: { id: null, name: null },
    profile: { id: null, name: null },
    windowType: { id: null, name: null, photo: null },
    windowOpeningType: { id: null, name: null, photo: null },
    safety: { id: null, name: null },
    colorInner: { id: null, name: null, photo: null },
    colorOuter: { id: null, name: null, photo: null },
    innovations: [],
  },
  stepsState: {},
  stepsIds: [],
});
